import React, { useState } from 'react';
import { getImageSet } from 'Util/DataUtils';
import icArrow1 from 'Assets/img/ic_arrow_right_16.png';
import icArrow2 from 'Assets/img/ic_arrow_right_16@2x.png';
import icArrow3 from 'Assets/img/ic_arrow_right_16@3x.png';
import IntlMessages from 'Util/IntlMessages';
import VerificationForm from 'Routes/sign-in/components/common/VerificationForm';
import { VERIFY_TYPE } from 'Routes/sign-in/components/LeftSide/constants';
import PasswordForm from 'Routes/sign-in/components/common/PasswordForm';
import { BUSINESS_TYPE } from '../../constants';
import BusinessTypeTab from './BusinessTypeTab';

const icArrow = getImageSet([icArrow1, icArrow2, icArrow3]);

const STEP = {
  VERIFY: 1,
  FIND_PASSWORD: 2,
};

const FindPasswordViSection = ({ onChangeLogin, onCompleted }) => {
  const [step, setStep] = useState(STEP.VERIFY);
  const [phone, setPhone] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [businessNumber, setBusinessNumber] = useState('');
  const [businessType, setBusinessType] = useState(BUSINESS_TYPE.INDIVIDUAL);
  const [showMethod, setShowMethod] = useState(false);

  const handleBack = () => {
    if (step === STEP.VERIFY) {
      onChangeLogin();
    } else {
      setStep(STEP.VERIFY);
    }
  };

  const handleGoToNext = ({ phone, otpCode, businessNumber }) => {
    setStep(STEP.FIND_PASSWORD);
    setPhone(phone);
    setOtpCode(otpCode);
    setBusinessNumber(businessNumber);
  };

  const getTitle = () => {
    if (step === STEP.FIND_PASSWORD) return 'signIn.join.findPassword.title';
    if (businessType === BUSINESS_TYPE.INDIVIDUAL) return 'signIn.join.phone.verify.title';
    return 'signIn.join.phone.verify';
  };

  const getSubTitle = () => {
    if (step === STEP.FIND_PASSWORD) return 'signIn.join.findPassword.sub';
    if (businessType === BUSINESS_TYPE.INDIVIDUAL) return 'signIn.join.phone.verify.sub';
    return 'signIn.join.phone.message';
  };

  return (
    <div className="inner-container">
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div
          className="cursor-pointer no-drag"
          style={{ backgroundColor: '#EEEEEE', borderRadius: '8px', width: '30px', height: '30px', minHeight: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          onClick={handleBack}
        >
          <img {...icArrow} alt="ic-arrow" style={{ transform: 'rotate(180deg)' }} />
        </div>
        {step === STEP.VERIFY && (
          <div style={{ color: '#666', fontSize: '15px', fontStyle: 'normal', fontWeight: '400', lineHeight: 'normal' }}>
            <IntlMessages id="signIn.login.findPassword" />
          </div>
        )}
      </div>
      <div className="title-container">
        <div className="title-main no-drag" style={{ fontSize: '28px', fontWeight: '600' }}>
          <IntlMessages id={getTitle()} />
        </div>
        <div className="title-sub">
          <IntlMessages id={getSubTitle()} />
        </div>
      </div>
      {step === STEP.VERIFY && (
        <>
          <BusinessTypeTab businessType={businessType} onChangeBusinessType={value => setBusinessType(value)} />
          <VerificationForm type={VERIFY_TYPE.FIND_PASSWORD} businessType={businessType} goToNext={handleGoToNext} />
        </>
      )}
      {step === STEP.FIND_PASSWORD && <PasswordForm onCompleted={onCompleted} managerPhone={phone} otpCode={otpCode} businessNumber={businessNumber} />}
      {step === STEP.VERIFY && businessType === BUSINESS_TYPE.INDIVIDUAL && (
        <div className="find-password-staff-wrapper">
          <div className="find-password-staff-title cursor-pointer no-drag" onClick={() => setShowMethod(!showMethod)}>
            <IntlMessages id="signIn.findPassword.staff.method" />
            <div className="find-password-staff-arrow">
              <img {...icArrow} alt="arrow" style={{ transform: showMethod ? 'rotate(270deg)' : 'rotate(90deg)' }} />
            </div>
          </div>
          {showMethod && (
            <div className="find-password-staff-sub">
              <IntlMessages id="signIn.findPassword.staff.sub" />
            </div>
          )}
        </div>
      )}
      <div className="join-text-wrapper" onClick={onChangeLogin}>
        <IntlMessages id="signIn.join.5" />{' '}
        <span className="join-text-blue">
          <IntlMessages id="signIn.join.4" />
        </span>
      </div>
    </div>
  );
};

export default FindPasswordViSection;
